var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.958 0.83034C15.6534 0.33363 16.5875 0.333629 17.2829 0.83034L30.7017 10.4152C31.4933 10.9806 31.0933 12.2289 30.1205 12.2289H29.1211V24.2289H31.1211V26.2289H1.12109V24.2289H3.12109V12.2289H2.12046C1.14763 12.2289 0.747591 10.9806 1.53922 10.4152L14.958 0.83034ZM25.1211 12.2289H27.1211V24.2289H25.1211V12.2289ZM21.1211 12.2289H23.1211V24.2289H21.1211V12.2289ZM17.1211 12.2289H19.1211V24.2289H17.1211V12.2289ZM13.1211 12.2289H15.1211V24.2289H13.1211V12.2289ZM9.12109 12.2289H11.1211V24.2289H9.12109V12.2289ZM5.12109 12.2289H7.12109V24.2289H5.12109V12.2289ZM27 10.2289L16.1205 2.45781L5.24093 10.2289H27Z",
    fill: "#46474C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12109 30.2289H31.1211V28.2289H1.12109V30.2289Z",
    fill: "#46474C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementBank);
export default __webpack_public_path__ + "static/media/icon_settlement_bank.13644de99d51c399b12f6b2bb43f0813.svg";
export { ForwardRef as ReactComponent };